import { ref } from 'vue'

export const shortcutsHelpOpen = ref(false)

export function openShortcutsHelp()   { shortcutsHelpOpen.value = true  }
export function closeShortcutsHelp()  { shortcutsHelpOpen.value = false }
export function toggleShortcutsHelp() { shortcutsHelpOpen.value = !shortcutsHelpOpen.value }
